"use strict";
import { defineComponent, onUpdated } from "vue";
import { MetaInfo } from "./MetaInfo.class";
export default defineComponent({
  setup: () => {
    const component = new MetaInfo();
    void component.setIndexableFlag();
    onUpdated(component.setIndexableFlag.bind(component));
    return {
      title: component.title,
      robots: component.robots,
      description: component.description,
      canonical: component.canonical,
      prerenderStatusCode: component.prerenderStatusCode,
      showPrerenderStatusCode: component.showPrerenderStatusCode,
      showPrerenderHeader: component.showPrerenderHeader,
      showRelPrev: component.showRelPrev,
      relPrev: component.relPrev,
      showRelNextPage2: component.showRelNextPage2,
      relNextPage2: component.relNextPage2,
      showRelNextPage3: component.showRelNextPage3,
      relNextPage3: component.relNextPage3,
      prerenderHeader: component.prerenderHeader
    };
  }
});
